import { locale } from './globals.js';
import { loadJSON, getYoutubeVideoID } from './toolbox.js'

let htmlBuffer = document.createElement('div');

class NewsFeed {
  constructor(el) {
    if(!el) return false
    this.el = el
    this.listHTML = this.el.querySelector('[data-news-list]')
    this.api = this.el.getAttribute('data-api')
    this.params = ''
    this.bookmark = 0
    this.initBatch = 11
    this.moreBatch = 8
    
    this.initFilters()
    loadJSON(`${this.api}`, this.init.bind(this))
  }
  initFilters() {
    this.filters = Array.from(this.el.querySelectorAll('[data-filter]'))
    if (this.filters.length < 1) return
    this.filters.forEach((filter) => {
      filter.addEventListener('change', this.updateParams.bind(this))
    })
  }
  updateParams() {
    let params = []
    this.filters.forEach((filter) => {
      if(filter.value == 'all') return
      params.push(`${filter.getAttribute('name')}=${filter.value}`)
    })
    this.params = params.join('&')
    this.updateData()
  }
  updateData() {
    let joiner = this.api.indexOf('?') > 0 ? '&' : '?'
    let params = this.params.length > 0 ? `${joiner}${this.params}` : ''
    loadJSON(`${this.api}${params}`, this.updateFeed.bind(this))
    // console.log("filter parameters: " + params)
  }
  updateFeed(data) {
    this.bookmark = 0
    this.updateState('ready')
    this.data = JSON.parse(data)
    // console.log(this.data)
    this.renderThumbs()
  }
  init(data) {
    this.updateState('ready')
    this.data = JSON.parse(data)
    // load templates
    this.loadTemplates()
    // load more button
    this.el.querySelector(['[data-load-more]']).addEventListener('click', this.renderThumbs.bind(this))
  }
  loadTemplates() {
    this.templates = {}

    Twig.twig({
      id: 'thumbs',
      href: '/assets/templates/news-list.html',
      load: (template) => {
        this.templates.thumbs = template
        this.renderThumbs()
      }
    })
  }
  renderThumbs() {
    let stateBuffer = this.state, batch
    if (this.state == 'ready') {

      if (this.data.slider) this.initBatch-- // save a spot for the slider
      batch = this.data.posts.slice(this.bookmark, this.bookmark += this.initBatch)
      if (this.data.slider) batch.splice(0, 0, {
        autoplay: this.data.autoplay,
        loop: this.data.loop,
        slider: this.data.slider
      });

      htmlBuffer.innerHTML = this.templates.thumbs.render({ feed: batch, locale })
      stateBuffer = 'loaded-partial'
      requestAnimationFrame(() => {
        this.listHTML.innerHTML = htmlBuffer.innerHTML
      })
    } else {
      batch = this.data.posts.slice(this.bookmark, this.bookmark += this.moreBatch)
      htmlBuffer.innerHTML = this.templates.thumbs.render({ feed: batch, locale })
      // append more thumbs
      requestAnimationFrame(() => {
        this.listHTML.querySelector(':scope > .news-thumb:last-child').insertAdjacentHTML('afterend', htmlBuffer.innerHTML)
      })
    }
    // no more data to load thumbs from
    if(this.bookmark >= this.data.posts.length) {
      stateBuffer = 'loaded-full'
    }
    requestAnimationFrame(() => {
      this.updateState(stateBuffer)
    })
    
    // console.log(this.bookmark, this.data.posts.length)
  }
  renderPopups() {
    this.popups = []
    this.data.forEach((memory) => {
      this.popups.push({
        memory,
        src: this.templates.popup.render({memory, origin: window.location.origin}),
        type: 'html'
      })
    })
    
  }

  // helpers
  updateState(state) {
    this.state = state;
    this.el.setAttribute('data-state', state)
  }
  getIDfromPath(p) {
    let path = p ? p : document.location.pathname
    let pathValues = path.split('/').filter(Boolean)
    return (pathValues[0] == 'memory') ? pathValues[1] : false
  }
}
new NewsFeed(document.querySelector('[data-news-feed]'))

